export const iconFontAwesomeAnimalsLocust = (
	<i className="fa-solid fa-locust"></i>
);
